import styled from '@emotion/styled'
import { Breadcrumbs } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const BreadcrumbsStyled = styled(Breadcrumbs)`
  text-transform: capitalize;
  padding: 0 ${newTheme.spacing.xm} ${newTheme.spacing.xm} ${newTheme.spacing.xm};

  .MuiBreadcrumbs-separator {
    svg {
      color: ${newTheme.colors.neutral.light};
    }
  }

  .MuiBreadcrumbs-li div {
    display: flex;
    align-items: center;
  }

  a {
    text-decoration: none;
    color: ${newTheme.colors.neutral.light};
    display: flex;

    &:hover {
      color: ${newTheme.colors.neutral.medium};
    }
  }

  #actual-route {
    font-family: ${newTheme.typography.family.primary};
    color: ${newTheme.colors.primary.main};
    text-transform: capitalize;
  }

  a,
  #actual-route {
    font-size: ${newTheme.typography.sizes['2xs']};
    font-weight: ${newTheme.typography.weight.xsm};
  }
`
